import { getBoardAgent } from "./board-agent-registry";
import type { BoardAgentActions } from "./hooks/board-agent-context";

const NO_ACTIVE_BOARD = {
	ok: false as const,
	error: "No active board",
};

/**
 * Resolves board actions at call time so mid-turn navigation off a board
 * returns a clear error instead of calling into an unmounted editor.
 */
export function createLiveBoardActionsProxy(): BoardAgentActions {
	return new Proxy({} as BoardAgentActions, {
		get(_target, prop) {
			if (typeof prop !== "string") {
				return undefined;
			}

			return (...args: unknown[]) => {
				const actions = getBoardAgent()?.actions;
				if (!actions) {
					return Promise.resolve(NO_ACTIVE_BOARD);
				}

				const method = actions[prop as keyof BoardAgentActions];
				if (typeof method !== "function") {
					return Promise.resolve(NO_ACTIVE_BOARD);
				}

				return (method as (...methodArgs: unknown[]) => unknown).apply(
					actions,
					args,
				);
			};
		},
	});
}
